import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Button,
  Collapse
} from '@mui/material';
import '../css/Sidebar.css';

const Sidebar = () => {
  const navigate = useNavigate();
  const userType = localStorage.getItem('userType');
  const companyName = localStorage.getItem('companyName');
  const companyId = localStorage.getItem('companyId');

  if (userType !== 'admin') return null;

  return (
    <Box className="sidebar-container">
      <List
        component="nav"
        subheader={<ListSubheader className="sidebar-title">Navigation</ListSubheader>}
        className="sidebar-list"
      >
        <ListItem button component={Link} to="/dashboard">
          <ListItemText primary="Mon Tableau de bord" />
        </ListItem>

        {companyName && (
          <ListItem button component={Link} to={`/company-details/${companyId}`}>
            <ListItemText primary={`Fiche d'entreprise : ${companyName}`} />
          </ListItem>
        )}

        <ListSubheader className="sidebar-section">Utilisateurs</ListSubheader>
        <Collapse in={true}>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/manage-users">
              <ListItemText primary="Gérer les utilisateurs" />
            </ListItem>
            <ListItem button component={Link} to="/add-user">
              <ListItemText primary="Ajouter un utilisateur" />
            </ListItem>
          </List>
        </Collapse>

        <ListSubheader className="sidebar-section">Entreprises</ListSubheader>
        <Collapse in={true}>
          <List component="div" disablePadding>
            <ListItem button component={Link} to="/manage-companies">
              <ListItemText primary="Gérer les entreprises" />
            </ListItem>
            <ListItem button component={Link} to="/add-company">
              <ListItemText primary="Ajouter une entreprise" />
            </ListItem>
          </List>
        </Collapse>

        <ListItem button component={Link} to="/profile">
          <ListItemText primary="Mes informations" />
        </ListItem>

        <ListItem>
          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              localStorage.removeItem('authToken');
              navigate('/login');
            }}
            fullWidth
            className="sidebar-logout-btn"
          >
            Déconnexion
          </Button>
        </ListItem>
      </List>
    </Box>
  );
};

export default Sidebar;
